import './index.scss'
import React, {useEffect, useState} from "react";
import {Toast} from "antd-mobile";
import Service from "@/view/supperzzle/service";
import qs from "query-string";
import Stepper from "@/components/Stepper";
import {confirmSimpleOrder, getPayParams, getTicketPrepaid} from "@/api/projectManager_self";
import {hideLoading, showLoading} from "@/components/loading";
const BuyPowerModal = ({ onClose, callBack, navigate, userInfo, fromGems, gemSTotalCounts }) => {
  const [buyNum, setBuyNum] = useState(1)
  const [gemsPrice, setGemsPrice] = useState(10)
  const [payDetail, setPayDetail] = useState()
  //获取支付信息
  const getPayDetail = async () => {
    const params = {
      activityCode: Service.activityCode,
      source: 'app',
      productId: 2,  // 1代表宝石乐园对对碰体力
    };
    try {
      showLoading()
      const {code, msg, data} = await getTicketPrepaid(params);
      if (code !== '000000') throw msg;
      hideLoading()
      setPayDetail(data?.info)
      setGemsPrice(data?.info?.gemsPrice || 0)
    } catch (e) {
      hideLoading()
      Toast.show(e);
    }
  }
  useEffect(() => {
    fromGems && getPayDetail()
  }, []);
  const gotoSalePay = () => {
    const params = {
      code: Service.activityCode,
    }

    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("Web", { uri: `${window.location.origin}/supperzzle/powerPay?${qs.stringify(params)}` });
    } else {
      navigate(`/supperzzle/powerPay?${qs.stringify(params)}`);
    }

  }
  const buyHandle = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.verifyRealName("请先实名认证").then(function (res) {
        if (res?.result) {
          onClose()
          gotoSalePay();
        }
      })
    } else {
      if(process.env.NODE_ENV === 'development'){
        onClose()
        gotoSalePay();
      }else {
        Toast.show("请至APP内购买")
      }

    }
  }
  const onCountChange = (value) => {
    setBuyNum(value)
  }
  const handleConfirmForGems = async () => {
    if(buyNum * gemsPrice > gemSTotalCounts) {
      return Toast.show('宝石不足')
    }
    const params = {
      totalNum: buyNum,
      totalUsePoint: 0,
      totalUseCash: 0,
      gemstonesNum: buyNum * gemsPrice,
      payType: "GEMSTONES",
      source: "app",
      type: "21",
      uid: payDetail.defRepeatStr,
      activityCode: "matchGame",
      productId: 2,
    }
    // console.log(params);
    // return
    try {
      showLoading();
      const orderInfo = await confirmSimpleOrder(params);
      if (orderInfo.code !== '000000') throw orderInfo.msg;
      hideLoading();
      onClose()
      // window.localStorage.setItem('buyPowerOrderNo', orderInfo?.data?.outTradeNo)
      callBack(orderInfo?.data?.outTradeNo)
    } catch (error) {
      hideLoading();
      onClose()
      Toast.show(error);
    }
  }
  return (
    <div className="buyPowerModal">
      <div className="buyPower_container">
        <div className="buyPower_title">水果补充</div>
        <div className="buyPower_content">
          <div className="gem_img_box">
            <img className="green_power_img" src={require('@/assets/img/supperzzle/powerIcon.png')} alt=""/>
            {fromGems && <div className="red_ball" >x10</div>}
          </div>
          {fromGems ? <div className="gem_stepper_box">
            <Stepper maxValue={payDetail?.maxNum || 10}
                     defaultValue={1}
                     minValue={1}
                     onChange={onCountChange}
            />
            <div className="gem_count_msg">消耗 <span className="red_span">{buyNum * gemsPrice}</span>宝石共<span className="yellow_span">{gemSTotalCounts}</span> 宝石</div>
          </div> : <div className="buyPower_textRow">水果<span className="buyPower_pointsVale">x{10}</span></div>}
        </div>
        <div className="buyPower_btnBox">
          {fromGems ? <button className={'exchangeBtn'} onClick={handleConfirmForGems}>确认</button> : <button className={'exchangeBtn'} onClick={buyHandle}>购买</button>}
          <button className={'cancelBtn'} onClick={onClose}>取消</button>
        </div>
      </div>
    </div>
  )
}
export default BuyPowerModal